import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@runner/ui/tokens.css';
import './styles/app.css';
import './styles/play.css';
import { App } from './app/App';
import { RouterProvider } from './app/router';
import { PrefsProvider } from './app/prefs';
import { WorldProvider } from './data/WorldProvider';
import { makeLocalWorld } from './data/chain/ChainWorld';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PrefsProvider>
      <RouterProvider>
        <WorldProvider makeLocal={makeLocalWorld}>
          <App />
        </WorldProvider>
      </RouterProvider>
    </PrefsProvider>
  </StrictMode>,
);
